<small style="display: none">{{ version }}</small>
@if (showContent()) {
  <router-outlet />
}
